export default {
  newDesign: true,
  title: "Çocuğunuz İçin Ücretsiz Çevrimiçi Tasarım ve Animasyon Dersi | Kodland",
  downtimeUrl: "http://kodland.org/tr",
  parameters: {
    landing_id: "TrQR",
    segment: 11,
  },
  startPage: {
    title:
      "Testi çözün ve ücretsiz dersi alın! 🔥",
    subtitle:
      "Çizim tutkusunu avantaja dönüştürüyoruz:<br>💬 Çocuğunuzun yeteneklerini eğlenceli bir şekilde keşfedin<br>🌐 Sadece bir bilgisayar ve internet bağlantısına ihtiyacınız var<br>💙 Sadece bugün 270’den fazla çocuk kaydoldu",
    image: {
      url: "/welcome/tr_fwd_review_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/tr_fwd_review_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Teste başla ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
  },
  quizRotateBySteps: {
    1: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/tr_fwd_review_1.png",
      title: "Dünya genelinde 30.000 çocuk Kodland’da eğitim alıyor",
      subtitle: "Çocuğunuzun arkadaşlar ve destek bulabileceği bir topluluk.",
      button: "Başla",
    },
    2: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz.",
      type: "age",
      button: "",
    },
    3: {
      question: "Çocuğunuz boş zamanlarında en çok ne yapmayı sever?",
      answers: [
        "Spor yapmak veya açık havada oyunlar 🏐",
        "Kitap veya çizgi roman okumak 📚",
        "Televizyon izlemek, YouTube veya video oyunları 🎮",
        "Çiz, boya ya da el işi yap ✏️🖍️",
        "Arkadaşlarıyla veya ailesiyle vakit geçirmek 👫",
        "Diğer 🙂"
      ],
    },
    4: {
      question: "Çocuğunuz en çok ne yapmayı sever?",
      answers: [
        "Karakter çizmek ve tasarlamak 🎨",
        "Hikâyelerle animasyon veya çizgi roman 🎬",
        "3D kahramanlar/dünyalar yapmak 🪐",
        "Logo, site veya çıkartma tasarımı ✏️",
        "Hepsini seviyor, tam emin değilim 🤔"
      ],
    },
    5: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/tr_fwd_review_5.png",
      title: "Kodland ile daha hızlı öğren",
      subtitle: "Etkileşimli dersler ve bire bir mentor desteği sayesinde konuları daha hızlı anlar ve çok daha uzun süre hatırlarsın.",
      button: "Başla",
    },
    6: {
      question: "Çocuğunuz bir şeyler yaratmayı veya arkadaşlarıyla etkinlikler yapmayı sever mi?",
      answers: [
        "Evet, grup içinde yaratıcı projeleri sever 👫🎨",
        "Bazen, aktiviteye bağlı 🤔",
        "Hayır, bireysel görevleri tercih eder 🧍💡"
      ],
    },
    7: {
      question: "Çocuğunuz bir hikâye anlattığında genellikle…",
      answers: [
        "Detaylara odaklanır 🧵📜",
        "Direkt ana fikre gider 🎯",
        "Mizah veya hayal gücü ekler 🤹✨",
        "Düşüncelerini organize etmekte zorlanır 🤔"
      ],
    },
    8: {
      question: "Çocuğunuz talimatları izlemeyi mi yoksa kendi fikirlerini üretmeyi mi tercih eder?",
      answers: [
        "Açık talimatları sever ✔️",
        "Yaratıcı fikirleri ve yeni yaklaşımları tercih eder 🎨",
        "Hem yapı hem özgürlüğü sever 🛠️",
        "Göreve bağlı: yapı veya yaratıcılık 👩‍🎨"
      ],
    },
    9: {
      question:
        "Çocuğunuzun çalışabileceği bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "☹️ Hayir",
          stopAnswer: true,
        },
      ],
    },
    10: {
      title: "Formu doldurun ve ders tarihini seçin",
      typeInfo: "congrats",
      subtitle:
        "Kodland uzmanlarının hazırladığı ücretsiz rehberi alın ve çocuğunuz için ücretsiz kodlama deneme dersine katılın.",
      button: "Hadi başlayalım!",
    },
    11: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    12: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    13: {
      title:
        "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    14: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    15: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    }
  },
};
